import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ServicesService } from '~shared/servicios/services.service';
import { InicioNComponent } from '../inicio-n.component';

@Component({
  selector: 'app-ayuda',
  templateUrl: './ayuda.component.html',
  styleUrls: ['./ayuda.component.scss']
})
export class AyudaComponent extends InicioNComponent implements OnInit {

  Preguntas: any[] = [
    {
      Cabeza: '¿Cómo empezar con Triidy?', titulo: '',
      texto: 'Creemos que Triidy es la solución para que tu ecommerce no pare de crecer, ya que te ahorramos el 35% de tus costos logísticos y puedes aumentar tus ventas hasta en un 150%, por eso, para empezar con nosotros sigue los siguientes pasos.' +
        '<ul>' +
        '<li>Dale click en “registrarme” e ingresa los datos para crear tu cuenta.</li>' +
        '<li>Mira el paso a paso de cómo iniciar en Triidy.</li>' +
        '<li>Configura tu producto propio o agrega uno dropshipping.</li>' +
        '<li>Solicita dinero en el Triidy boost o recarga el monedero si vas a vender productos dropshipping.</li>' +
        '<li>Comienza a vender y aumenta tus ganancias.</li>' +
        '</ul>',
      idCabeza: 'headingOne', target: 'collapseOne'
    },
    {
      Cabeza: '¿Qué es Triidy y cómo funciona?', titulo: '',
      texto: 'Somos una plataforma digital que conecta el ecosistema de los comercios electrónicos, permitiéndoles llevar todo el control de su negocio en una sola pantalla, proveedores de productos, transportadoras de entrega, base de datos de clientes, y recursos financieros generando soluciones personalizadas de acuerdo a la big data del sistema.' +
        '<br> En Triidy podrás crear tus propios productos, agregar uno dropshipping o traer tus propios proveedores, vender en más de 1100 municipios en Colombia, entender los gustos de tus clientes y administrar tus finanzas.',
      idCabeza: 'headingTwo', target: 'collapseTwo'
    },
    {
      Cabeza: '¿Cuanto cuesta usar Triidy?', titulo: '',
      texto: 'En Triidy existimos para ayudar a los emprendedores digitales a darse cuenta de su verdadero potencial, por ello el uso de nuestra plataforma es totalmente gratuita (aplica términos y condiciones), tu solo pagas el valor de los envíos que generes con nosotros.',
      idCabeza: 'headingThree', target: 'collapseThree'
    },
    {
      Cabeza: '¿En que paises puedo usar Triidy?', titulo: '',
      texto: 'Nuestro sistema escalable te permite vender desde cualquier país en el mundo, envía productos a más de 1100 municipios de Colombia ya que nuestra billetera digital y el sistema dropshipping no tienen fronteras.',
      idCabeza: 'headingFour', target: 'collapseFour'
    },
    {
      Cabeza: '¿Qué es el dropshipping y cómo puedo hacer dropshipping con Triidy?', titulo: '',
      texto: 'Es un método de envío y entrega de pedidos minoristas en el cual no es necesario que la tienda tenga los productos que vende en el almacén. En cambio, cuando la tienda vende un producto, lo compra de un tercero y lo hace enviar directamente al cliente. Como resultado, el comerciante nunca ve o manipula el producto.' +
        '<br> En Triidy tenemos más de 30 proveedores y 2000 productos disponibles para que tu los promociones con tus clientes y vendas solo a demanda, permitiéndote ahorrar costos logísticos hasta en un 100% ya que el proveedor despacha por ti, además podrás aumentar tus ventas en un 150%, dado que vas a tener mucho más tiempo para vender y fidelizar tus clientes.',
      idCabeza: 'headingFive', target: 'collapseFive'
    },
    {
      Cabeza: '¿Necesito tener un ecommerce para usar Triidy?', titulo: '',
      texto: 'No necesitas un ecommerce ya que Triidy es una plataforma que organiza los procesos logísticos de los negocios ya sean de ventas online u offline.',
      idCabeza: 'headingSix', target: 'collapseSix'
    },
    {
      Cabeza: '¿Puedo realizar mis envíos con Triidy?', titulo: '',
      texto: 'Si, puedes realizar tus envíos en Triidy con 3 transportadoras diferentes, llegando con tus productos a más de 1.100 municipios en Colombia, lo mejor es que por medio de la data te mostramos las ciudades donde más vendes para hacer que las entregas pasen de días a horas.',
      idCabeza: 'headingSeven', target: 'collapseSeven'
    },
    {
      Cabeza: '¿Puedo conectar mi página web con Triidy?', titulo: '',
      texto: 'Si tienes tu página web en shopify, que es el mayor proveedor de sitios para ecommerce, podrás conectarte por medio de api con Triidy, para que tus ventas bajen en tiempo real y el proceso de facturación y despacho sea mucho más rápido y efectivo.',
      idCabeza: 'headingEight', target: 'collapseEight'
    },
    {
      Cabeza: '¿Para qué sirve la billetera virtual de Triidy?', titulo: '',
      texto: 'Nuestra billetera virtual te permite realizar más de 12 funciones entre las más importantes está comprar mercancía a proveedores, pagar los envíos, adelantar el dinero de tus ventas contra entrega, solicitar dinero para comprar a proveedores, llevar el control de tus finanzas y mucho más.',
      idCabeza: 'headingNine', target: 'collapseNine'
    }
  ]

  constructor(public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar) {
    super(router, service, cookieSvc, snackBar);
  }

  ngOnInit(): void {
  }

  clickM() {
    this.service.emitChange(true);
  }
}
